export const data = {
  heading: "Tools & Frameworks for Cross\u2011platform App Development",
  paragraph: "Our development stack leverages industry-leading technologies, including Flutter, React Native, Kotlin Multiplatform (KMP), .NET MAUI and Ionic, alongside essential tools like Expo, Firebase, and AWS Amplify. We evaluate performance metrics, app size, and long-term maintainability to select the right stack for your business.",
  lastParagraph:"When you choose between React Native and Flutter, it is important to understand how their underlying architectures impact your project’s lifecycle and specific product goals. Use the comparison table below to help determine the best fit for your app:",
  // CTA:"Request a Custom Quote",
    tableData: {
    thead: [
      "Feature",
      "Flutter",
      "React Native"

    ],
    tbody: [
      [
        "Rendering Engine",
        "Skia/Impeller (Directly draws UI)",
        "Native Components (Via Bridge/Fabric)",
        
      ],
      [
        'Programming Language',
        "Dart",
        "JavaScript / TypeScript",
        
      ],
      [
        "Learning Curve",
        "Moderate (Consistent UI-as-code)",
        "Familiar for Web/React developers",
        
      ],[
        "Ecosystem",
        "Specialized & highly integrated",
        "Massive (Access to NPM libraries)",
        
      ],
      [
        "Backed By",
        "Google",
        "Meta",
      ],
      [
        "Best For",
        "High-performance, custom-branded UI",
        "Ecosystem-heavy, enterprise SaaS apps"
      ]
    
    
    ],
  },
};